// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XU67","field":"styles_field__1p0YU","fieldCol":"styles_fieldCol__up2U5","diffCol":"styles_diffCol__3Xw64","diff":"styles_diff__TdAI4"};